import {
  FEATURE_FLAG_TOGGLE,
  FEATURE_FLAGS_LOAD_FAILURE,
  FEATURE_FLAGS_LOAD_SUCCESS,
  FEATURE_FLAGS_LOAD,
} from './types';

/**
 * Fetch feature flags from service.
 *
 * @param {[String]} userId The id of current user.
 * @param {[Object]} attributes Additional user attributes.
 * @return {Object}
 */
export function loadFeatureFlags(userId, attributes) {
  return {
    type: FEATURE_FLAGS_LOAD,
    payload: {
      userId,
      attributes,
    },
  };
}

/**
 * Load all feature flags into store. Existing flags will be cleared.
 *
 * @param {Object[]} flags List of feature flag objects.
 * @return {Object}
 */
export function loadFeatureFlagsSuccess(flags) {
  return {
    type: FEATURE_FLAGS_LOAD_SUCCESS,
    payload: {
      flags,
    },
  };
}

/**
 * Load all feature flags into store. Existing flags will be cleared.
 *
 * @param {Error} error The error object.
 * @return {Object}
 */
export function loadFeatureFlagsFailure(error) {
  return {
    type: FEATURE_FLAGS_LOAD_FAILURE,
    error: true,
    payload: error,
  };
}

/**
 * Toggle a feature flag.
 *
 * @param {string} id The id of feature flag.
 * @return {Object}
 */
export function toggleFeatureFlag(id) {
  return {
    type: FEATURE_FLAG_TOGGLE,
    payload: {
      id,
    },
  };
}
